import { Quote } from "lucide-react";

const testimonials = [
  {
    quote: "My daughter was so nervous on day one, but by day three she couldn't stop talking about it! The coaches are amazing with shy kids.",
    parent: "Sarah M.",
    child: "Mum of Emily, age 8",
  },
  {
    quote: "Finally found a holiday activity that my energetic son actually wants to go to! He's learned so much about focus and discipline.",
    parent: "James T.",
    child: "Dad of Oliver, age 10",
  },
  {
    quote: "The flexibility of the 5-day pass is perfect for our busy family. We've spread the days across Easter and summer.",
    parent: "Michelle R.",
    child: "Mum of twins, age 7",
  },
  {
    quote: "The passport is such a brilliant idea — my son shows everyone his stickers! It really motivates him to learn new skills.",
    parent: "David L.",
    child: "Dad of Ethan, age 9",
  },
];

export default function TestimonialsSection() {
  return (
    <section
      id="testimonials"
      className="py-20 bg-[#0A1A2F]"
      data-testid="testimonials-section"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-[#D4A857]/20 text-[#D4A857] px-4 py-2 rounded text-sm font-bold uppercase tracking-wide mb-4 font-['Montserrat']">
            <Quote size={16} />
            Happy Families
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-4 font-['Montserrat']">
            What Parents <span className="text-[#D4A857]">Say</span>
          </h2>
          <p className="text-lg text-white/70 max-w-2xl mx-auto font-['Lato']">
            Don't just take our word for it — hear from families who've experienced the magic!
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 gap-6">
          {testimonials.map((testimonial, i) => (
            <div
              key={i}
              className="bg-white rounded-lg p-6 relative"
              data-testid={`testimonial-${i}`}
            >
              {/* Quote */}
              <Quote className="text-[#D4A857]/20 absolute top-4 right-4" size={40} />
              
              <p className="text-[#0A1A2F] text-lg mb-4 leading-relaxed relative z-10 font-['Lato']">
                "{testimonial.quote}"
              </p>
              
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#0A1A2F] font-['Montserrat']">{testimonial.parent}</p>
                  <p className="text-gray-500 text-sm font-['Lato']">{testimonial.child}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Masky Footer - Small */}
        <div className="mt-12 text-center">
          <img
            src="https://customer-assets.emergentagent.com/job_1abea0ec-cded-4678-a29f-de28c813ea65/artifacts/2pfnnew9_bigger%20masky.png"
            alt="Masky"
            className="w-36 mx-auto mb-4 masky-glow"
          />
          <p className="text-[#D4A857] font-bold text-lg font-['Montserrat']">
            "Every review makes me smile!"
          </p>
        </div>
      </div>
    </section>
  );
}
